import NumberValue from './NumberValue';

export default NumberValue;
